import { useProperties } from 'state';
import InfoActionHeader from '../InfoActionHeader';

/**
 * PropertiesStats
 *
 * @return {JSX.Element}
 */
const PropertiesStats = ({ className, ...rest }) => {
  const properties = useProperties();

  const infoData = [
    { key: 'properties', value: properties.data.length, label: 'Properties' },
    { key: 'tenancies', value: properties.tenanciesCount, label: 'Tenancies' },
    {
      key: 'occupancy',
      value: `${properties.occupancyValue}%`,
      label: 'Occupancy',
    },
  ];

  return <InfoActionHeader {...rest} items={infoData} />;
};

PropertiesStats.displayName = 'PropertiesStats';

export default PropertiesStats;
